/* eslint-disable no-mixed-operators */
import { useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import {
  wsGetValidaCancelacion,
  wsGetValidaCancelacionLabo
} from "../../../context/Actions/turnos/cancelacion";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import "./CardTurnoFooter.css";
import DocumentoIcon from "../../../assets/images/generico/DocumentoIcon";
import PagarSeguro from "../../../assets/images/generico/PagarSeguro";
import {
  IdTurnoSolicitud,
  limpiarDatosMedico,
  limpiarListaMultimedia,
  limpiarMatriculaMedico,
  limpiarPlanKinesio,
  limpiarTipoTurno,
  resetIdTurnoSolicitud,
  wsGetPlanKinesio,
} from "../../../context/Actions/turnos/turnosPaciente";
import { mercadoPagoReset } from "../../../context/Actions/mercadoPago/mercadoPago";
import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "../../../../global/context/Provider";
import { useEffect } from "react";

/**
 * True si el turno todavia no paso. Decision 2026-09-11: el boton Confirmar se
 * muestra siempre que el turno no este confirmado (sin ventana de 72hs como el
 * push T-3). fecha viene como ISO "2026-09-18T00:00:00", hora como "16:40".
 * Si algo no parsea, mostramos el boton igual.
 */
const turnoFuturo = (turno) => {
  const fecha = new Date(turno?.fecha);
  if (Number.isNaN(fecha.getTime())) return true;
  const [hh, mm] = String(turno?.hora || "").split(":").map(Number);
  if (!Number.isNaN(hh)) fecha.setHours(hh, Number.isNaN(mm) ? 0 : mm, 0, 0);
  return fecha.getTime() > Date.now();
};

const CardTurnoFooter = ({ idPacienteFamiliar, recargoTurnos, turno }) => {
  const {
    modalDispatch,
    cancelacionState,
    cancelacionDispatch,
    motivoCancelacionState,
    turnosPacienteDispatch,
    mercadoPagoDispatch,
    ordenEstudioState,
    textosState,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [flgValidacion, setFlgValidacion] = useState(false);
  // Boton "Confirmar" de la card: DESHABILITADO 2026-09-24, ver comentario en el JSX.
  // eslint-disable-next-line no-unused-vars
  const showModalConfirmarTurno = () => {
    showModal(
      "Turnos/ConfirmarTurnoModal/ConfirmarTurnoModal",
      {
        turno: turno,
        idPacienteFamiliar: idPacienteFamiliar,
        onConfirmado: recargoTurnos,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  // Kinesio no confirma por sesion (tampoco cancela desde aca). Cancelado/atendido
  // no deberian llegar a la lista, pero por las dudas.
  // eslint-disable-next-line no-unused-vars
  const puedeConfirmar =
    !turno.confirmado &&
    !turno.cancelado &&
    !turno.atendido &&
    turno.idTurnoSesion <= 0 &&
    turnoFuturo(turno);

  let config = localStorage.getItem("config");
  let mercadoPagoJson = JSON.parse(config).mercadoPago;

  const validaCancelacion = () => {
    if (turno.idProtocolo > 0) {
      showModalCancelarTurno();
      wsGetValidaCancelacionLabo(
        turno.idturno,
        idPacienteFamiliar
      )(cancelacionDispatch);
      setFlgValidacion(true);
    } else {
      showModalCancelarTurno();
      wsGetValidaCancelacion(
        turno.idturno,
        idPacienteFamiliar
      )(cancelacionDispatch);
      setFlgValidacion(true);
    }
  };

  const showModalCancelarTurno = () => {
    if (!cancelacionState.cancelacion.error) {
      showModal(
        "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
        {
          titulo: "Cancelar turno",
          texto: `Desea cancelar ${turno.videoConsulta === true ? "la video consulta" : "su turno"
            } de ${turno.especialidad} del ${getDiaStrTurno(
              turno.fecha
            )} ${getDiaStrTurno(turno.fecha, true)} a las ${turno.hora} ${amOrPm(
              turno.hora
            )} ?`,
          items: turno.idProtocolo
            ? motivoCancelacionState.motivoCancelacion.laboratorio
            : motivoCancelacionState.motivoCancelacion.turnos,
          idturno: turno.idturno,
          idProtocolo: turno.idProtocolo,
          idTurnoSesion: turno.idTurnoSesion,
          idPacienteFamiliar: idPacienteFamiliar,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const dissmiss = (origen, estado, mensaje) => {
    if (origen === "mercadoPago") {
      if (estado) {
        showToaster(
          {
            texto: mensaje,
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        showToaster(
          {
            texto: mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
      hideModal()(modalDispatch);
      mercadoPagoReset()(mercadoPagoDispatch);
      recargoTurnos();
    } else {
      hideModal()(modalDispatch);
      limpiarPlanKinesio()(turnosPacienteDispatch);
      limpiarDatosMedico()(turnosPacienteDispatch);
      limpiarListaMultimedia()(turnosPacienteDispatch);
      limpiarMatriculaMedico()(turnosPacienteDispatch);
      limpiarTipoTurno()(turnosPacienteDispatch);
      resetIdTurnoSolicitud()(turnosPacienteDispatch);
    }
    localStorage.setItem("alertaActive", "false");
  };

  const showModalAdjuntarOrden = (editOrden) => {
    if (editOrden) {
      showModal(
        "Genericos/EditarOrden/EditarOrden",
        {
          turno: turno,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    } else {
      showModal(
        "Genericos/ModalSubirOrden/ModalSubirOrden",
        {
          turno: turno,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const showModalMatriculaMedico = (e) => {
    IdTurnoSolicitud(e)(turnosPacienteDispatch);
    showModal(
      "Turnos/MatriculaModal/MatriculaModal",
      {
        titulo: "Médico Solicitante",
        idturno: turno.idturno,
        idProtocolo: turno.idProtocolo,
        idPacienteFamiliar,
        medSolicitanteDto: turno.medSolicitanteDto,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalPlanKinesio = () => {
    wsGetPlanKinesio(
      turno.idTurnoSesion,
      idPacienteFamiliar
    )(turnosPacienteDispatch);
    showModal(
      "Turnos/PlanKinesio/PlanKinesio",
      {
        titulo: "Plan de Sesiones",
        fecha: turno.fecha,
        hora: turno.hora,
        especialidad: turno.especialidad,
        idTurnoSesion: turno.idTurnoSesion,
        idPacienteFamiliar: idPacienteFamiliar,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalAbonarTurno = () => {
    showModal(
      "Turnos/AbonaTurno/AbonaTurno",
      {
        idturno: turno.idturno,
        idProtocolo: turno.idProtocolo,
        monto: turno.monto,
        fecha: turno.fecha,
        hora: turno.hora,
        centro: turno.centro,
        especialidad: turno.especialidad,
        dismiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalPreparaciones = () => {
    showModal(
      "Turnos/Preparaciones/Preparaciones",
      {
        titulo: "Preparaciones",
        preparacion: turno.preparacion,
        autorizacion: turno.requiereAutorizacion,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  useEffect(() => {
    if (flgValidacion === true) {
      showModalCancelarTurno();
    } else if (cancelacionState.cancelacion.error) {
      showToaster(
        {
          texto: cancelacionState.cancelacion.validaCancelacion,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    //eslint-disable-next-line
  }, [flgValidacion]);

  return <div className="ptur-card-cardTurno-footer">
    {turno.preparacion && <button
      className="ptur-button bgc-latex30 rb16m c-white"
      onClick={() => showModalPreparaciones()}
    >
      <span>Ver preparaciones</span>
    </button>
    }
    {mercadoPagoJson && turno.monto > 0 && !turno.flgSaldada && ((turno.subeFotoOrden && turno.estadoOrden === "Validado") || !turno.subeFotoOrden) && (
      <button
        className="ptur-button bgc-danger rb16m c-white"
        onClick={() => showModalAbonarTurno()}
      >
        <PagarSeguro />
        <span>Abonar turno</span>
      </button>
    )}
    {turno.subeFotoOrden && !turno.tieneFotoOrden && (
      <button
        className="ptur-button bgc-danger rb16m c-white"
        onClick={() => showModalAdjuntarOrden()}
      >
        {ordenEstudioState.ordenEstudio.loading ? (
          <IonSpinner name="lines-small" />
        ) : (
          <>
            <DocumentoIcon />
            <span>Subir orden médica</span>
          </>
        )}
      </button>
    )}
    {!turno.medSolicitanteDto && turno.subeFotoOrden && (
      <button
        className="ptur-button bgc-danger rb16m c-white"
        onClick={() => showModalMatriculaMedico(turno.idturno)}
      >
        {ordenEstudioState.ordenEstudio.loading ? (
          <IonSpinner name="lines-small" />
        ) : (
          <>
            <DocumentoIcon />
            <span>Ingresar Médico Solicitante</span>
          </>
        )}
      </button>
    )}
    {turno.idTurnoSesion > 0 && (
      <button
        className="ptur-button bgc-latex10 rb16m c-white"
        onClick={() => showModalPlanKinesio()}
      >
        Ver plan de sesiones
      </button>
    )}
    {turno.estadoOrden === "Pendiente" && turno.tieneFotoOrden || turno.estadoOrden === "Rechazado" &&
      <button
        className="ptur-button borderer rb16m c-latex30"
        onClick={() => showModalAdjuntarOrden(true)}
      >
        Editar orden
      </button>
    }
    {turno.idTurnoSesion <= 0 &&
      <button
        className="ptur-button borderer rb16m c-latex30"
        onClick={validaCancelacion}
      >
        Cancelar turno
      </button>
    }
    {/* DESHABILITADO 2026-09-24 (pedido de negocio): el boton "Confirmar" de la card
        queda comentado hasta definir la ventana de confirmacion (48hs o 24hs antes,
        segun el turno). Sigue funcionando la confirmacion desde el push (boton y tap
        del banner → ConfirmarTurnoModal) y la leyenda "Turno confirmado".
        Para reactivarlo: reemplazar el boton de arriba por esta fila.
    {turno.idTurnoSesion <= 0 &&
      <div className="ptur-card-cardTurno-footer-row">
        <button
          className="ptur-button borderer rb16m c-latex30"
          onClick={validaCancelacion}
        >
          {puedeConfirmar ? "Cancelar" : "Cancelar turno"}
        </button>
        {puedeConfirmar && (
          <button
            className="ptur-button bgc-confirmar rb16m c-white"
            onClick={showModalConfirmarTurno}
          >
            Confirmar
          </button>
        )}
      </div>
    }
    */}
  </div>;
};

export default CardTurnoFooter;
